import React from 'react'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'

/**
 * Icon con mắt ẩn/hiện dùng chung cho MỌI ô mật khẩu của cụm "Tài khoản liên kết" (20/09/2026).
 *
 * Vì sao có file này thay vì để antd tự vẽ: mặc định `Input.Password` gắn `aria-label="eye"` /
 * `"eye-invisible"` (tên icon tiếng Anh) — lạc lõng trong app đã Việt hoá toàn cục và không nói rõ
 * bấm vào thì xảy ra chuyện gì. `iconRender` dưới đây giữ nguyên icon của antd, chỉ thay tên truy
 * cập bằng chữ Việt; `@ant-design/icons` trải `restProps` SAU `aria-label` mặc định nên prop truyền
 * vào thắng.
 *
 * 🔴 Phạm vi: chỉ dùng cho ô NGƯỜI DÙNG TỰ GÕ (mật khẩu xác thực, mật khẩu khi Thêm, "Mật khẩu
 * mới" khi Sửa). KHÔNG dùng để phơi mật khẩu CŨ của tài khoản liên kết — BRD `FR-W-03` /
 * `BR-11` / `BR-12` bắt mật khẩu cũ phải đi qua luồng xác thực `FR-W-05`, không có đường tắt.
 *
 * DOM hook: antd gắn thêm class `ant-input-password-icon` lên chính phần tử trả về; test tìm nút
 * theo `aria-label` (hai hằng dưới đây), không bám vào tên icon của antd.
 */

export const PASSWORD_SHOW_ARIA_LABEL = 'Hiện mật khẩu'
export const PASSWORD_HIDE_ARIA_LABEL = 'Ẩn mật khẩu'

export const renderPasswordVisibilityIcon = (visible: boolean): React.ReactNode => (
  visible
    ? <EyeOutlined aria-label={PASSWORD_HIDE_ARIA_LABEL} />
    : <EyeInvisibleOutlined aria-label={PASSWORD_SHOW_ARIA_LABEL} />
)
